module.exports = __webpack_public_path__ + "media/images/icons/arrow-0cef1c21abf5c4cdf60378044f2c8c42.svg";